@if (!reload) {
    <div data-bb="canvas-width" [ngClass]="{ 'canvas-small': !fullWidth, 'canvas-full': fullWidth }">
        <div>
            <div class="mijn-actie-template__header">
                <div>
                    <h1 class="mijn-actie-template__title">{{ title }}</h1>
                    @if (subtitle) {
                        <p class="mijn-actie-template__subtitle ap-small">{{ subtitle }}</p>
                    }
                </div>
                <div class="mijn-actie-template__actionBlock">
                    @if (contextHelp) {
                        <ap-icon-button-link
                            (click)="onContextHelp($event)"
                            iconName="question-circle"
                            data-bb="contextHelp"
                            class="ap-lt-md-hide"
                        >
                            {{ 'mijn.actie.template.contextHelp.button' | apContent }}
                        </ap-icon-button-link>
                    }
                    @if (contextHelp) {
                        <ap-icon
                            (click)="onContextHelp($event)"
                            name="question-circle"
                            size="large"
                            color="secondary"
                            data-bb="contextHelp"
                            class="context-help ap-gt-sm-hide"
                        >
                        </ap-icon>
                    }
                    @if (showCloseButton) {
                        <ap-action-icon (click)="close()" [ariaLabel]="'mijn.actie.template.close.aria-label' | apContent" data-bb="close">
                            <ap-icon name="close" size="large" color="secondary"> </ap-icon>
                        </ap-action-icon>
                    }
                </div>
            </div>
        </div>
        <div class="mijn-actie-template__body" mijn-analyse>
            <ng-content></ng-content>
        </div>

        @if (conversationalEnabled) {
            <mijn-overzicht-template-conversational
                [changeConversationalStatus$]="changeConversationalStatus$"
                (chatNotificationSent)="chatNotificationSent.emit($event)"
            ></mijn-overzicht-template-conversational>
        }
    </div>
}
